module.exports = __webpack_public_path__ + "static/media/1.e1b2bd83.jpg";